import { Skeleton as UiSkeleton, styled } from "@l2r-front/l2r-ui"

export const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    padding: theme.spacing(8),
}))

export const TabPanel = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(5),

    "&:not([hidden])": {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
    },
}))

export const ButtonsContainer = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(6),
}))

export const Skeleton = styled(UiSkeleton)(({ theme }) => ({
    marginTop: theme.spacing(28),
    padding: theme.spacing(8),
    position: "absolute",
    minHeight: `calc(100% - ${theme.spacing(28)})`,
    transform: "scale(1)",
    left: theme.spacing(8),
    width: `calc(100% - ${theme.spacing(16)})`,
}))

export const SkeletonContainer = styled("div")(() => ({
    minHeight: "100%",
    width: "100%",
}))